export default __webpack_public_path__ + "static/media/title_pc@2x.cc59b941.png";